"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
exports.default = (0, intl_1.defineMessages)({
    // ========
    // ========
    // appointment_cancel.
    // ========
    // ========
    // error.*
    // ========
    apptCancelationFailed: {
        id: 'appointment_cancel.error.cancelation_failed',
        description: "The message to display in a warning banner if a user's attempt to cancel an appointment fails.",
        defaultMessage: 'Cancelation failed. Please call us at {phone_number_link}.'
    },
    apptCancelationFailedNoProvider: {
        id: 'appointment_cancel.error.cancelation_failed_no_provider',
        description: "The message to display in a warning banner if a user's attempt to cancel an appointment fails. This is an alternate version used if provider isn't loaded.",
        defaultMessage: 'Cancelation failed. Please contact the office directly to cancel this appointment.'
    },
    cancelationDisabledHeading: {
        id: 'appointment_cancel.error.cancelation_disabled.heading',
        description: 'Heading text for cancelation disabled error page',
        defaultMessage: 'Further Action Required'
    },
    cancelationDisabledBanner: {
        id: 'appointment_cancel.error.cancelation_disabled.banner',
        description: 'Banner text for cancelation disabled error page',
        defaultMessage: "We're unable to cancel your appointment online at this time. Please call your provider's office. {phone_number_link}"
    },
    cancelationDisabledBannerNoProvider: {
        id: 'appointment_cancel.error.cancelation_disabled.banner_no_provider',
        description: 'Banner text for cancelation disabled error page when no provider is loaded as is the case in PMAC today',
        defaultMessage: "We're unable to cancel your appointment online at this time. Please call your provider's office."
    },
    cancelationExpiredBanner: {
        id: 'appointment_cancel.error.cancelation_expired.banner',
        description: 'Banner text for cancelation expired error page',
        defaultMessage: "We're unable to cancel online this close to the appointment start time. Please call your provider's office."
    },
    cancelationExpiredBannerNoProvider: {
        id: 'appointment_cancel.error.cancelation_expired.banner_no_provider',
        description: 'Banner text for cancelation expired error page when no provider is loaded as is the case in PMAC today',
        defaultMessage: "We're unable to cancel online this close to the appointment start time. Please call your provider's office."
    },
    appointmentMissed: {
        id: 'appointment_cancel.error.appointment_missed.banner',
        description: 'The banner text displayed when the user has missed their appointment.',
        defaultMessage: "We're unable to cancel or reschedule online at this time. Please call your provider's office."
    },
    appointmentMissedNoProvider: {
        id: 'appointment_cancel.error.appointment_missed.banner_no_provider',
        description: 'The banner text displayed when the user has missed their appointment and when no provider is loaded as is the case in PMAC today',
        defaultMessage: "We're unable to cancel or reschedule online at this time. Please call your provider's office."
    },
    // cancel_page.*
    // ========
    pageHeading: {
        id: 'appointment_cancel.cancel_page.page_heading',
        description: 'Heading text for cancelation page',
        defaultMessage: 'Do you want to cancel this appointment?'
    },
    labelEmailInput: {
        id: 'appointment_cancel.cancel_page.email_input_label',
        description: 'Label for email input on the cancelation page',
        defaultMessage: 'Email'
    },
    consentEmailRequiredMsg: {
        id: 'appointment_cancel.cancel_page.email_consent_error',
        description: 'Message to display if user has not consented to receive emails (when receiving emails is required)',
        defaultMessage: 'Willingness to receive confirmation email is required'
    },
    cancelApptButton: {
        id: 'appointment_cancel.cancel_page.cancel_appointment_button',
        description: 'Text for cancel appointment button',
        defaultMessage: 'Cancel Appointment'
    },
    goBack: {
        id: 'appointment_cancel.back',
        description: 'Text for the Back button in the stepper that brings users to the previous step',
        defaultMessage: 'Back'
    },
    // confirmation_page.*
    // ========
    previouslyCanceledPageHeading: {
        id: 'appointment_cancel.confirmation_page.previously_canceled_page_heading',
        description: 'Heading text for the confirmation page when the appointment was previously canceled',
        defaultMessage: 'This appointment has already been canceled. No further action is required.'
    },
    confirmPageHeading: {
        id: 'appointment_cancel.confirmation_page.page_heading',
        description: 'Heading text for appointment cancel confirmation page',
        defaultMessage: 'Appointment Canceled'
    },
    confirmPageDescription: {
        id: 'appointment_cancel.confirmation_page.page_description',
        description: 'Description text for appointment cancel confirmation page',
        defaultMessage: 'Your appointment with {provider_name} has been canceled for {appointment_date} at {appointment_time}. You will receive a confirmation email shortly.'
    },
    rescheduleHeading: {
        id: 'appointment_cancel.confirmation_page.reschedule_provider_heading',
        description: 'Heading text for rescheduling with current provider on the appointment cancel confirmation page',
        defaultMessage: 'Want to reschedule with {provider_name}?'
    },
    rescheduleUnnamedHeading: {
        id: 'appointment_cancel.confirmation_page.reschedule_unnamed_provider_heading',
        description: 'Temporary heading text for rescheduling with current unnamed provider on the appointment cancel confirmation page. This will be replaced by reschedule_current_provider_heading once all apps have provider data coming in.',
        defaultMessage: 'Would you like to reschedule?'
    },
    rescheduleLinkText: {
        id: 'appointment_cancel.confirmation_page.reschedule_link_text',
        description: 'Button-link text for rescheduling with current provider on the appointment cancel confirmation page',
        defaultMessage: 'Book Appointment'
    },
    newSearchHeading: {
        id: 'appointment_cancel.confirmation_page.new_search_heading',
        description: 'Heading text for scheduling with a new provider on the appointment cancel confirmation page',
        defaultMessage: 'Looking for a new provider?'
    },
    newSearchLinkText: {
        id: 'appointment_cancel.confirmation_page.new_search_link_text',
        description: 'Button-link text for scheduling with a new provider on the appointment cancel confirmation page',
        defaultMessage: 'Search Providers'
    },
    // not_found.*
    // ========
    apptNotFoundBanner: {
        id: 'appointment_cancel.not_found.banner-v2',
        description: 'The banner text for the appointment cancel 404 page. Customers should override this and provide a phone number for users to contact.',
        defaultMessage: 'This page doesn’t exist. Please call the health system number listed in your appointment confirmation email.'
    },
    // form_fields.*
    // ========
    confirmText: {
        id: 'appointment_cancel.form.confirm_email',
        description: 'The message to display confirm email consent from user.',
        defaultMessage: 'Confirmation email may contain personal and protected health information.'
    },
    confirmModalTitle: {
        id: 'appointment_cancel.form.confirm_modal_title',
        description: 'Title text of confirm modal box',
        defaultMessage: 'Risks of Emailing Health Information'
    },
    confirmModalContent: {
        id: 'appointment_cancel.form.confirm_modal_content',
        description: 'Content of confirm modal box',
        defaultMessage: 'The Health Insurance Portability and Accountability Act of 1996 (HIPAA) recommends that e-mail containing protected health information be encrypted. We cannot guarantee that appointment confirmation e-mails will be encrypted and therefore it is possible that the confidentiality of such communications may be breached by a third party.\
      E-mails can easily be circulated and forwarded to unintended recipients.\
      Backup copies of e-mails may exist even after the recipient has deleted his or her copy.\
      Employers and on-line services have a right to inspect e-mails transmitted through their systems.\
      E-mails may be able to be intercepted, altered, forwarded, or used without authorization or detection.'
    },
    learnMoreLink: {
        id: 'appointment_cancel.form.learn_more_link',
        description: 'anchor link text of learn more link to open modal',
        defaultMessage: 'Learn more about the risks of e-mailing this information.'
    },
    emailErrorMsg: {
        id: 'appointment_cancel.form.email_error_msg',
        description: 'The warning message to dispaly when enter invalid email format',
        defaultMessage: 'Email format address@example.com'
    },
    emailPlaceholder: {
        id: 'appointment_cancel.form.email_placeholder',
        description: 'Email input field placeholder text',
        defaultMessage: 'username@email.com'
    },
    consentEmail: {
        id: 'appointment_cancel.form.consent_email',
        description: 'Consent to email label text',
        defaultMessage: 'Consent to email'
    },
    cancelationReasonNotesTitle: {
        id: 'appointment_cancel.form.cancelation_reason_notes',
        description: 'Consent to email label text',
        defaultMessage: 'Reason for cancelation (optional)'
    },
    selectReasonAlert: {
        id: 'appointment_cancel.info.selectReasonAlert',
        description: 'The message to display info banner on the reschedule reason selection page.',
        defaultMessage: 'Please provide a reason for canceling the appointment.'
    },
    reasonPlaceholder: {
        id: 'appointment_cancel.btn.reasonPlaceholder',
        description: 'The placeholder text for the reason input field.',
        defaultMessage: 'Select'
    },
    reasonLabel: {
        id: 'appointment_cancel.btn.reasonLabel',
        description: 'The label text for the reason input field.',
        defaultMessage: 'Reason (optional)'
    }
});
//# sourceMappingURL=messages.js.map